// @flow

import * as React from 'react'
import './bar.css'

type Props = {|
  value: number,
  total: number,
  color: string,
|}

type State = {|
  percent: number,
|}

class Bar extends React.Component<Props, State> {
  state = {
    percent: 0,
  }

  componentDidMount() {
    // Initial Animation
    if (this.props.value > 0) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.setState({
            percent: this.props.value / this.props.total * 100,
          })
        })
      })
    }
  }
  componentDidUpdate(newProps: Props) {
    // Update state and re-animate on props change
    if (this.props.total !== newProps.total) {
      this.setState({
        percent: this.props.value / this.props.total * 100,
      })
    }
  }

  render() {
    return (
      <div className="bar-container">
        <div className="bar-content" style={{ width: this.state.percent + '%', backgroundColor: this.props.color }} />
        <div className="bar-text">{this.props.value + '/' + this.props.total}</div>
      </div>
    )
  }
}

export default Bar



// WEBPACK FOOTER //
// ./src/reports/bar.js